
        var result = require("!!../../../../../node_modules/css-loader/index.js!./gas-statistics.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/gas/gas-statistics/gas-statistics.component.css
// module id = 788
// module chunks = 0